import { AssetHeadlineFigure } from "@hydrologiq/gql-experience/graphql"
import Current, { CurrentUnit } from "@hydrologiq/shared/figures/generic/Current"
import { isCompactFigure } from "@hydrologiq/shared/figures/generic/figureVariant"

interface CurrentPowerFigureProps {
  data?: AssetHeadlineFigure
  loading?: boolean
  error?: string
  isPlaceholder?: boolean
  compact?: boolean
}

function CurrentPowerFigure({ data, loading, error, isPlaceholder, compact = isCompactFigure("summary") }: CurrentPowerFigureProps) {
  return (
    <Current
      heading={data?.label}
      current={data?.value ?? undefined}
      unit={(data?.unit as CurrentUnit) ?? "kW"}
      loading={loading}
      isPlaceholder={!data?.available || error !== undefined || isPlaceholder}
      error={error}
      compact={compact}
    />
  )
}

export default CurrentPowerFigure
